/**
 * Fred Olsen Cruise Lines Dynamica LTT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Header { 
    departureId?: string;
    cruiseName?: string;
    cabinGrade?: string;
    benchmarkDepartureId?: string;
    benchmarkRegion?: string;
    benchmarkDepartureDate?: string;
    cluster?: string;
}

